import { CSSObject } from '@chakra-ui/react';

export const WrapperContent: CSSObject = {
  display: 'flex',
  flexDir: 'column',
  py: ['4', null, '10'],
  px: ['2', null, '10'],
  flex: [null, null, 1],
  justifyContent: [null, null, 'center'],
  minW: ['unset', null, '460px'],
  maxW: '100vw',
  bg: 'white',
  borderRightRadius: [null, null, '10px'],
  borderTop: '0',
  borderColor: 'beta.300',
  fontFamily: 'accent',
  form: {
    '.chakra-form-control': {
      '.chakra-form__label': {
        color: 'beta.800',
        fontSize: 'xs',
        fontWeight: 'semibold',
        fontFamily: 'body',
      },
    },
    'a[href*="forgot-password"]': {
      color: 'delta.500',
      fontWeight: 'bold',
      fontSize: 'xs',
      fontFamily: 'body',
      mt: '2',
    },
    '.chakra-button[data-cy*="loginSubmit"]': {
      textShadow: '0px 4px 4px 0px var(--bc-colors-blackAlpha-400)',
      fontWeight: 'bold',
      textTransform: 'uppercase',
    },
    '.chakra-form__error-message': {
      bg: 'red.600',
      boxShadow:
        '0px 2px 4px 0px var(--bc-colors-blackAlpha-400),0px 1px 0px 0px var(--bc-colors-whiteAlpha-400) inset',
      borderRadius: 'md',
      p: '1',
      color: 'white',
      fontWeight: 'medium',
      fontSize: 'xs',
      fontFamily: 'body',
    },
    'button[aria-label*="password toggle"]': {
      top: '-1px',
      color: 'gray.500',
    },
    'input:-webkit-autofill, input:-webkit-autofill:focus': {
      transition: 'background-color 0s 600000s, color 0s 600000s',
    },
  },
};

export const Title: CSSObject = {
  color: 'beta.800',
  fontSize: 'lg',
  fontFamily: 'heading',
  fontStyle: 'normal',
  fontWeight: 'normal',
  textTransform: 'uppercase',
  mb: '4',
  mt: [null, null, '9'],
};
